
import React, { useContext } from 'react'
import { RootStoreContext } from '../../../app/stores/rootStore';
import { Button } from 'reactstrap';
import classNames from "classnames";
import { useTranslation } from 'react-i18next';
import { translationHookOptions } from '../../../app/localization/localization';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';

 const ZoomPortionButton  : React.FC= () => {
    const rootStore = useContext(RootStoreContext);
    const { theme } = rootStore.commonStore;
    const {sendSharedWidget}= rootStore.tenantStore;
    const { isZoomPortionEnabled,setZoomPortionEnabled , setSharedObject } = rootStore.playerStore;
    const [t] = useTranslation(["browse_page"], translationHookOptions);
    const {isZoomed, originalzoomPortionDivStyle, setZoomPortionDiv, zoomPortionDivStyle,initializeZoomPortion}= rootStore.zwibblerStore;
    const handleClick = () => {
      // setZoomPortionDiv(originalzoomPortionDivStyle.top , originalzoomPortionDivStyle.left , originalzoomPortionDivStyle.width , originalzoomPortionDivStyle.height , originalzoomPortionDivStyle.position.x , originalzoomPortionDivStyle.position.y)
      initializeZoomPortion();
      setZoomPortionEnabled(!isZoomPortionEnabled);
     if(isZoomPortionEnabled){
   
         setSharedObject();  
         sendSharedWidget(); 
     }
       };
  return (
   <>
   <Button
      disabled={isZoomed}
        id="zoomPortion"
        className={classNames(
          "px-1 pt-1 pb-1 transparentButton toolbarButton divButton",
          // offset-md-3
          isZoomPortionEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i
          className={classNames(
            "fas fa-search-plus iconToolbarButton",
            isZoomPortionEnabled ? "" : ""
          )}
        ></i>
        <h6 className="textToolbarButton mb-0">{t("toolbar_zoom_portion_button")}</h6>
      </Button>
   </>
     )
};

export default observer(ZoomPortionButton);
